import { render, staticRenderFns } from "./FileDownloadNotification.vue?vue&type=template&id=eddb575e"
import script from "./FileDownloadNotification.vue?vue&type=script&lang=js"
export * from "./FileDownloadNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports